import { networkCall } from "../../../../../utils/network-call/network-call";

export const CompanyAdminUserListLoader = async () => {
    const getUsersResponse = await networkCall('/users');
    return { getUsersResponse };
};